export interface ScoreDetailsType {
  status: ScoreStatusEnums;
  reportDetails: ReportDetailsType;
  nonReportDetails: {
    daysReportBlockedFor: number;
  };
}
export interface ReportDetailsType {
  score: number;
  maxScore: number;
  scoreBand: string;
  lastUpdated: Date;
  scoreChange: number;
}

export interface BandType {
  bandTitle: string;
  scoreRange: string;
  bandDescription: string;
  isCurrent: boolean;
}

export enum AdvertEnums {
  DO_MORE = "doMore",
  BIOMETRIC_LOGIN = "biometricLogin",
  MARKETING = "marketing",
  BALANCES = "balances",
  REASONS_TO_STAY = "reasonsToStay",
  FULL_SCORE_BUILDERS = "fullScoreBuilders"
}

export enum ScoreStatusEnums {
  PASSED = "Passed",
  THIN_FILE = "ThinFile",
  FAILED = "Failed"
}

export enum JourneyEnums {
  SECURED_LOAN = "securedloan",
  DASHBOARD = "dashboard",
  CREDIT_CARD = "creditcard",
  PERSONAL_LOAN = "personalloan",
  OFFLINE_CARD = "offlinecard"
}

